export default __webpack_public_path__ + "static/media/php.14cb9d63.svg";